import { makeStyles } from '@material-ui/styles'

export const useClasses = makeStyles((theme) => ({
  root: {
    display: 'flex',
    overflow: 'scroll',
    gap: theme.spacing(1),
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  chip: {
    flex: 0,
    width: 'fit-content',
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(2.5),
    '& .MuiChip-label': {
      padding: 0,
      lineHeight: 1.1,
      fontSize: theme.typography.pxToRem(14),
    },
    '&[data-activity=true]': {
      backgroundColor: theme.palette.statement.filter.cashbackColor,
      '& .MuiChip-label': {
        color: theme.palette.statement.filter.cashbackTextColor,
      },
    },
    '&[data-activity=false]': {
      backgroundColor: theme.palette.statement.filter.color,
      '& .MuiChip-label': {
        color: theme.palette.statement.filter.textColor,
      },
    },
  },
}))
